import {useTranslation} from "react-i18next";
import Logo from '../../Assets/images/logo/connectcaremintgreen.png';
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {PrimaryButton} from "../../Components/Buttons/PrimaryButton";
import {useBoundStore} from "../../Store/store";
import {useEffect, useRef, useState} from "react";
import toast from "react-hot-toast";

export const AcceptShiftChangeRequest = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const acceptShiftChangeRequest = useBoundStore(state => state.acceptShiftChangeRequest);
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams()

    const [error, setError] = useState(false);
    const calledRef = useRef(false);

    const user = useBoundStore(state => state.user);

    useEffect(() => {
        if (calledRef.current) return;
        if(!user){
            toast.error(t('auth.not_logged_in'));
            navigate('/login');
            return;
        }

        setError(false);
        const s = searchParams.get('s');
        if(!s){
            navigate('/');
            return;
        }

        calledRef.current = true;
        acceptShiftChangeRequest(params?.id, s).then(() => {}).catch(error => {
            toast.error(t('auth.invalid_link'));
            setError(true);
        });
    }, [acceptShiftChangeRequest]);

    return (
        <div className={'flex flex-col justify-center h-screen w-full'}>
            <div className={'p-3 text-center'}>
                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
            </div>
            <div className={'p-3 w-full max-w-[80%] md:max-w-[50%] mx-auto'}>
                {
                    error && (
                        <>
                            <p>{t('shift_change.invalid_link')}</p>

                            <div className={'flex flex-row justify-center mt-4'}>
                                <PrimaryButton
                                    onClick={() => {
                                        navigate('/');
                                    }}
                                >
                                    {t('shift_change.back_to_homepage')}
                                </PrimaryButton>
                            </div>
                        </>
                    )
                }

                {
                    !error && (
                        <>
                            <p>
                                {t('shift_change.accept_success')}
                            </p>

                            <div className={'flex flex-row justify-center mt-4'}>
                                <PrimaryButton
                                    onClick={() => {
                                        navigate('/');
                                    }}
                                >
                                    {t('login.cta_dashboard')}
                                </PrimaryButton>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
}